import { render, staticRenderFns } from "./CollegeScore.vue?vue&type=template&id=0ea58a9c&scoped=true"
import script from "./CollegeScore.vue?vue&type=script&lang=js"
export * from "./CollegeScore.vue?vue&type=script&lang=js"
import style0 from "./CollegeScore.vue?vue&type=style&index=0&id=0ea58a9c&prod&scoped=true&lang=less"
import style1 from "./CollegeScore.vue?vue&type=style&index=1&id=0ea58a9c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea58a9c",
  null
  
)

export default component.exports